"use client";

import dynamic from "next/dynamic";
import Link from "next/link";
import { FileText, Info } from "lucide-react";
import type { SerializedEditorState } from "lexical";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const Editor = dynamic(() => import("@/components/editor/editor").then((m) => m.Editor), { ssr: false });

type Props = {
  content: string | null;
};

export function EventInfoBlock({ content }: Props) {
  let parsed: SerializedEditorState | undefined;
  if (content) {
    try {
      const json = JSON.parse(content);
      if (json?.root) parsed = json as SerializedEditorState;
    } catch {}
  }

  return (
    <Card className="min-h-[500px]">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <Info className="h-4 w-4" />
          Event Infos
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {parsed ? <Editor readOnly editorSerializedState={parsed} /> : <p className="text-sm text-muted-foreground">Es sind noch keine Event-Infos hinterlegt.</p>}
        <Button variant="outline" size="sm" asChild>
          <Link href="/home/atb" className="inline-flex items-center gap-2">
            <FileText className="h-4 w-4" />
            Allgemeine Teilnehmer Bedingungen
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
}
